import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { ApiRoutes } from '../api-routes';
import { Observable } from 'rxjs';

@Injectable()
export class InegiService {

  constructor(private http: HttpClient, private routes: ApiRoutes) {

  }
  getAddress(zipCode: string): any {
    return this.http.get(this.routes.herokuAPI + zipCode);
  }

  getState(state: string): Observable<any> {
    return this.http.get(this.routes.geoWebState + state);
  }

  getCounty(county: string): Observable<any> {
    return this.http.get(this.routes.geoWebCounty + county);
  }

  getCity(stateKey: string, countyKey: string): Observable<any> {
    return this.http.get(this.routes.geoWebLocality + stateKey + '/' + countyKey);
  }

  getNeighborhood(stateKey: string, countyKey: string): Observable<any> {
    return this.http.get(this.routes.geoWebNeighborhood + stateKey + '/' + countyKey)
  }

  getStreet(stateKey: string, countyKey: string): Observable<any> {
    return this.http.get(this.routes.geoWebStreet + stateKey + '/' +countyKey);
  }

}
